<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="float-right">
                    <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMen1" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false"
                            v-if="viewOnly && showCancelBatchButton">
                        Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                        <button class="dropdown-item" @click="onCancelDeliveryBatchClick">
                            Cancel Batch
                        </button>
                        <button class="dropdown-item" @click="openRescheduleModal">
                            Reschedule
                        </button>
                    </div>
<!--                    <button class="btn btn-primary" v-if="viewOnly && showCancelBatchButton" @click="cancelDeliveryBatch" :disabled="loading">-->
<!--                        Cancel Batch-->
<!--                    </button>-->
                </div>
                <div class="form-group">
                    <label>Vehicle</label>
                    <div class="text-danger" v-if="schedulingDetails.vehicleId.hasError">
                        {{schedulingDetails.vehicleId.errorMessage}}
                    </div>
                    <p v-if="viewOnly">
                        {{schedulingDetails.vehicle}}
                    </p>
                    <bootstrap-select :selectOptions="vehicles" :selectedOption="schedulingDetails.vehicleId.value" :elementId="'vehicleSelect'"
                                      :returnSelectedOptionText="true"
                                      @changeSelect="onVehicleSelect"
                                      v-if="!viewOnly"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label>Driver</label>
                    <div class="text-danger" v-if="schedulingDetails.driverId.hasError">
                        {{schedulingDetails.driverId.errorMessage}}
                    </div>
                    <p v-if="viewOnly">
                        {{schedulingDetails.driver}}
                    </p>
                    <bootstrap-select :selectOptions="drivers" :selectedOption="schedulingDetails.driverId.value" :elementId="'driverSelect'"
                                      :returnSelectedOptionText="true"
                                      @changeSelect="onDriverSelect"
                                      v-if="!viewOnly"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label>Date Of Departure</label>
                    <div class="text-danger" v-if="schedulingDetails.dateOfDeparture.hasError">
                        {{schedulingDetails.dateOfDeparture.errorMessage}}
                    </div>
                    <p v-if="viewOnly">
                        {{schedulingDetails.dateOfDeparture.value}}
                    </p>
                    <date-picker :format="'DD/MM/YYYY'" :elementId="'dateOfDepartureSelect'" :date="schedulingDetails.dateOfDeparture.value"
                                 @dateChange="onDateOfDepartureSelect"
                                v-if="!viewOnly"></date-picker>
                </div>
                <div class="form-group">
                    <label>Expected Date of Delivery</label>
                    <div class="text-danger" v-if="schedulingDetails.expectedDateOfDelivery.hasError">
                        {{schedulingDetails.expectedDateOfDelivery.errorMessage}}
                    </div>
                    <p v-if="viewOnly">
                        {{schedulingDetails.expectedDateOfDelivery.viewValue}}
                    </p>
                    <date-picker :format="'DD/MM/YYYY'" :elementId="'expectedDateOfDeliverySelect'" :date="schedulingDetails.expectedDateOfDelivery.value"
                                 @dateChange="onExpectedDateOfDeliverySelect"
                                 :initialiseDate="initialiseExpectedDateOfDelivery"
                                 v-if="!viewOnly"></date-picker>
                </div>
                <div class="form-group">
                    <label>SBO</label>
                    <div class="text-danger" v-if="schedulingDetails.sbo.hasError">
                        {{schedulingDetails.sbo.errorMessage}}
                    </div>
                    <p v-if="viewOnly">
                        {{schedulingDetails.sbo.value}}
                    </p>
                    <input type="text" class="form-control" v-model="schedulingDetails.sbo.value" v-if="!viewOnly"/>
                </div>
            </div>
        </div>

        <div class="col-xl-12">
            <div class="card-box">
                <ul class="pagination justify-content-center pt-3" v-if="!viewOnly">
                    <li class="page-item">
                        <a class="page-link" href="javascript: void(0);" aria-label="Previous" @click="onPreviousOrderClick"
                           v-show="currentOrderIndex > 0">
                            <span aria-hidden="true">«</span>
                            <span class="sr-only">Previous</span>
                        </a>
                    </li>
                    <li class="page-item" :class="{'active': order.isCurrentOrder}" v-for="order in orders">
                        <a class="page-link" href="javascript: void(0);" @click="onOrderClick(order)">
                            Order #{{order.orderId}}
                        </a>
                    </li>
                    <li class="page-item">
                        <a class="page-link" href="javascript: void(0);" aria-label="Next" @click="onNextOrderClick"
                           v-show="currentOrderIndex < orders.length - 1">
                            <span aria-hidden="true">»</span>
                            <span class="sr-only">Next</span>
                        </a>
                    </li>
                </ul>


                <ul class="pagination justify-content-center pt-3" v-if="viewOnly">
                    <li class="page-item">
                        <a class="page-link" href="javascript: void(0);" aria-label="Previous" @click="onPreviousOrderClick"
                           v-show="currentOrderIndex > 0">
                            <span aria-hidden="true">«</span>
                            <span class="sr-only">Previous</span>
                        </a>
                    </li>
                    <li class="page-item" :class="{'active': order.isCurrentOrder}" v-for="order in orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries">
                        <a class="page-link" href="javascript: void(0);" @click="onOrderClick(order)">
                            Order #{{order.orderId}}
                        </a>
                    </li>
                    <li class="page-item">
                        <a class="page-link" href="javascript: void(0);" aria-label="Next" @click="onNextOrderClick"
                           v-show="currentOrderIndex < orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries.length - 1">
                            <span aria-hidden="true">»</span>
                            <span class="sr-only">Next</span>
                        </a>
                    </li>
                </ul>
                
                <div class="pt-3">
                    <h3>
                        Order Details
                    </h3>
                    <p>
                        <b>Customer:</b> {{currentOrder.registeredCompanyName}}
                    </p>
                    
                    <p v-if="currentOrder.insertedOn !== undefined">
                        <b>Order Date:</b> {{currentOrder.insertedOn}}
                    </p>
                    <p v-if="currentOrder.dateOrderPlaced !== undefined">
                        <b>Order Date:</b> {{currentOrder.dateOrderPlaced}}
                    </p>
                    
                    <p>
                        <b>Order Type:</b> Delivery
                    </p>
                    
                    <p v-if="currentOrder.description !== undefined">
                        <b>Order Status:</b> {{currentOrder.description}}
                    </p>
                    <p v-if="currentOrder.orderStatus !== undefined">
                        <b>Order Status:</b> {{currentOrder.orderStatus}}
                    </p>
                </div>
                <div class="card border border-secondary mb-3">
                    <div class="card-body text-secondary">
                        <div class="row">
                            <div class="col-6">
                                <h5 class="card-title text-secondary">Billing Address</h5>
                                <p v-if="!loadingBillingAddress">
                                        <span v-if="billingAddress">
                                            {{ billingAddress.siteName }}<br>
                                            {{ billingAddress.streetAddress }}<br>
                                            {{ billingAddress.city }} <br>
                                            {{ billingAddress.province }} <br>
                                            {{ billingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                    <span v-else>
                                            No billing address found.
                                        </span>
                                </p>
                                <p v-if="loadingBillingAddress">Loading...</p>
                            </div>
                            <div class="col-6">
                                <h5 class="card-title text-secondary">Shipping Address</h5>
                                <p v-if="!loadingBillingAddress">
                                        <span v-if="shippingAddress">
                                            {{ shippingAddress.siteName }}<br>
                                            {{ shippingAddress.streetAddress }}<br>
                                            {{ shippingAddress.city }} <br>
                                            {{ shippingAddress.province }} <br>
                                            {{ shippingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                    <span v-else>
                                            No shipping address found.
                                        </span>
                                </p>
                                <p v-if="loadingBillingAddress">Loading...</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="card border border-secondary mb-3">
                    <div class="text-danger">
                        {{notAllOrdersHaveCompartmentsAssignedMessage}}
                    </div>
                    <div class="card-body text-secondary">
                        <h5 class="card-title">
                            Assign Compartments
                        </h5>
<!--                        <div v-for="summary in orderDeliveryVehicleCompartmentProductsSummary">-->
<!--                            <label>{{summary.compartmentName}}</label>-->
<!--                            <div class="progress mb-0 mt-0">-->
<!--                                <div class="progress-bar" role="progressbar" :style="{width: summary.percentageOfMaxCapacity + '%'}"-->
<!--                                     aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">{{summary.percentageOfMaxCapacity}}%-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <p>{{summary.instructedQuantity}}L of {{summary.compartmentMaxCapacity}}L</p>-->
<!--                        </div>-->
                        <div class="text-danger" v-if="(orderDeliveryVehicleCompartmentProductsSummary == null || orderDeliveryVehicleCompartmentProductsSummary.length === 0) && hasLoadedVehicleCompartments && !viewOnly">
                            The selected vehicle does not have compartments. Please select another vehicle
                        </div>
                        <order-items-compartment-assigning-table
                            :orderId="currentOrder.orderId"
                            :vehicleId="schedulingDetails.vehicleId.value"
                            :orderDeliveryId="currentOrder.orderDeliveryId"
                            :compartmentsAssigned="assignedCompartments.compartments"
                            :viewOnly="viewOnly"
                            :orderDeliveryVehicleCompartmentProductsSummary="orderDeliveryVehicleCompartmentProductsSummary"
                            @assignCompartments="onAssignCompartments"></order-items-compartment-assigning-table>

                    </div>
                </div>
            </div>
        </div>
        
        <button class="btn btn-primary" @click="validateScheduleOrderForDeliverySubmit" :disabled="loading" v-show="!viewOnly">
            Schedule Orders
        </button>
    </div>
    
    <select-vehicle-compartments-for-order-modal
        :orderId="currentOrder.orderId"
        :showModal="assignedCompartments.showAssignCompartmentModal"
        :product="assignedCompartments.orderItem"
        :vehicleId="schedulingDetails.vehicleId.value"
        :compartmentsWithAssignedProducts="assignedCompartments.compartments"
        @closeModal="onSelectVehicleCompartmentsForOrderModalClose"
        @save="onCompartmentSave"></select-vehicle-compartments-for-order-modal>

    <modal-form
            :heading="rescheduleModal.modalHeading"
            :modalId="rescheduleModal.elementId"
            :isSaving="rescheduleModal.isSaving"
            :showModal="rescheduleModal.showModal"
            @closeClicked="rescheduleModal.showModal = false"
            @saveButtonClicked="onRescheduleSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label>Driver</label>
                    <div class="text-danger" v-if="schedulingDetails.driverId.hasError">
                        {{schedulingDetails.driverId.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="drivers" :selectedOption="schedulingDetails.driverId.value" :elementId="'driverSelect'"
                                      :returnSelectedOptionText="true"
                                      @changeSelect="onDriverSelect"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label>Expected Date of Delivery</label>
                    <div class="text-danger" v-if="schedulingDetails.expectedDateOfDelivery.hasError">
                        {{schedulingDetails.expectedDateOfDelivery.errorMessage}}
                    </div>
                    <date-picker :format="'DD/MM/YYYY'" :elementId="'expectedDateOfDeliveryRescheduleSelect'" :date="schedulingDetails.expectedDateOfDelivery.value"
                                 @dateChange="onExpectedDateOfDeliverySelect"
                                 :initialiseDate="initialiseExpectedDateOfDelivery"></date-picker>
                </div>
            </form>
        </template>
    </modal-form>

    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="successModal.elementId"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="successModelOkClicked"></success-modal>
    
    <confirm-delete-modal
        :elementId="confirmDeliveryBatchCancelModal.elementId"
        :message="confirmDeliveryBatchCancelModal.modalMessage"
        :showModal="confirmDeliveryBatchCancelModal.showModal"
        :loading="confirmDeliveryBatchCancelModal.isSaving"
        :modalTitle="confirmDeliveryBatchCancelModal.modalHeading"
        @deleteConfirmed="onCancelDeliveryBatchConfirm"></confirm-delete-modal>
</div>
